<template>
  <div v-if="show">
    <label data-test="label-and-info-link-modal-label" class="label-and-info-link-modal">
      <span data-test="label-and-info-link-modal-span" v-html="renderLabelValue" />
    </label>
    <base-info-link-modal
      v-if="showInfoLinkModal"
      :title="infoLinkModalOption.title"
      :content="infoLinkModalOption.content"
      :button-label="infoLinkModalOption.buttonLabel"
      :link-label="infoLinkModalOption.linkLabel"
      :align-right="infoLinkModalOption.alignRight"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import Utility from '@/common/UtilityFunctions.js';
import BaseInfoLinkModal from '@/components/Forms/BaseInfoLinkModal/BaseInfoLinkModal.vue';
import { BaseInfoLinkModalProps } from '@/components/Forms/BaseInfoLinkModal/types/BaseInfoLinkModal';

export default defineComponent({
  name: 'LabelAndInfoLinkModal',
  components: { BaseInfoLinkModal },
  props: {
    label: {
      type: String,
      default() {
        return null;
      }
    },
    infoLinkModalOption: {
      type: Object as PropType<BaseInfoLinkModalProps>,
      default() {
        return null;
      }
    }
  },
  computed: {
    renderLabelValue() {
      return Utility.decodeHtml(this.label);
    },
    show() {
      if (!this.label || this.label === '') {
        return false;
      }
      return true;
    },
    showInfoLinkModal() {
      if (!this.infoLinkModalOption) {
        return false;
      }
      return true;
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all.scss';
@import 'node_modules/foundation-sites/scss/util/util';

.label-and-info-link-modal {
  display: inline-block;

  span:first-child {
    margin-right: rem-calc(15);
  }
}
</style>
@/components/Feature/Forms/BaseInfoLinkModal/BaseInfoLinkModal.vue@/components/Feature/Forms/BaseInfoLinkModal/types/BaseInfoLinkModal
